import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import '../../fonts/fonts.css'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2rem 2rem 1.5rem;
  background: white;
`

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 1.25rem;
`

const IconBox = styled.div`
  width: 4.0625rem;
  height: 4.0625rem;
  border-radius: 0.9375rem;
  background: linear-gradient(223deg, rgba(0,200,248,1) 16%, rgba(104,94,252,1) 78%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 4px 16px rgba(100,98,252,0.22);
`

const IconImg = styled.img`
  width: 2.125rem;
  height: 2.125rem;
  object-fit: contain;
  filter: brightness(0) invert(1);
`

const Title = styled.h1`
  font-family: Poppins;
  font-size: 2rem;
  font-weight: 600;
  color: #000000;
  margin: 0;
  line-height: 1.15;
`

const Subtitle = styled.p`
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 400;
  color: #000000;
  opacity: 0.5;
  margin: 0;
`

const Divider = styled.div`
  height: 1px;
  background: linear-gradient(90deg, #EFF0F6 0%, #E4E5F0 50%, #EFF0F6 100%);
  margin: 0 2rem 1.5rem;
`

/**
 * Reusable modern page header — gradient icon box + title + optional subtitle + optional right-side action.
 *
 * @param {string}    icon      - Icon image src
 * @param {string}    title     - Page title
 * @param {string}    [subtitle]- Optional subtitle text
 * @param {ReactNode} [children]- Optional right-side content (CTA button, etc.)
 */
const PageHeader = ({ icon, title, subtitle, children }) => (
  <>
    <Wrapper>
      <Left>
        <IconBox>
          <IconImg src={icon} alt='' />
        </IconBox>
        <div>
          <Title>{title}</Title>
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </div>
      </Left>
      {children && <div>{children}</div>}
    </Wrapper>
    <Divider />
  </>
)

export default PageHeader

/* ── Exported action components ───────────────────────────────── */

export const HeaderLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  height: 2.75rem;
  padding: 0 1.375rem;
  background: linear-gradient(135deg, #00C4F3 0%, #6462FC 100%);
  border-radius: 10px;
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 600;
  color: white;
  text-decoration: none;
  box-shadow: 0 4px 14px rgba(100,98,252,0.28);
  transition: opacity 0.15s, transform 0.15s, box-shadow 0.15s;
  & img {
    width: 1.05rem;
    height: 1.05rem;
    object-fit: contain;
    filter: brightness(0) invert(1);
  }
  &:hover { opacity: 0.9; transform: translateY(-1px); box-shadow: 0 6px 18px rgba(100,98,252,0.36); }
  &:active { transform: translateY(0); }
`

export const HeaderButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  height: 2.75rem;
  padding: 0 1.375rem;
  background: linear-gradient(135deg, #00C4F3 0%, #6462FC 100%);
  border-radius: 10px;
  border: none;
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 600;
  color: white;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(100,98,252,0.28);
  transition: opacity 0.15s, transform 0.15s, box-shadow 0.15s;
  & img {
    width: 1.05rem;
    height: 1.05rem;
    object-fit: contain;
    filter: brightness(0) invert(1);
  }
  &:hover { opacity: 0.9; transform: translateY(-1px); box-shadow: 0 6px 18px rgba(100,98,252,0.36); }
  &:active { transform: translateY(0); }
`
